interface Props {
  text?: string;
  className?: string;
}

export function Tagged({ text, className }: Props) {
  return (
    <span className={`relative z-10 rounded-full bg-brand-hover px-3 py-1.5 text-medium ${className}`}>{text}</span>
  );
}
